export const jsonToParamsRequest = (json: any) => {
  return Object.keys(json).map((k) => {
    return encodeURIComponent(k) + '=' + encodeURIComponent(json[k]);
  }).join('&');
};
